
    /**
    * 发送短信
    * 
    **/
    
    // @ts-nocheck
    import request from '../utils/http'
    type Serve<T, G> = (data?: T) => Promise<G>
    /**
 * OfficalSmsCheckCodeParam :OfficalSmsCheckCodeParam
 */
export class IReqApiEmployeeSmsSend28735 {
  /**
   * 线索编号
   */
  clewNo: string;
  /**
   * 手机号
   */
  mobile: string;
  /**
   * 图形验证码
   */
  graphCode: string;
}
    /**
 * YResult<Void> :YResult
 */
export class IResApiEmployeeSmsSend28735 {
  code?: {};
  msg?: {};
  success?: {};
  /**
   * Void
   */
  data?: {};
  exceptionMsg?: {};
}
    const http: Serve<IReqApiEmployeeSmsSend28735, IResApiEmployeeSmsSend28735> = (data?) =>  request({
      method: 'POST',
      url: '/api/employee/sms/send',
      data:data,
      headers:{'Content-Type': 'application/json;charset=UTF-8'}
    }) 
    export default http